import axiosClient from './axiosClient';

export type ScopeType = 'global' | 'customer' | 'sponsor' | 'tenant';
export type AccessLevel = 'read' | 'write';

export interface AccessGrant {
  id: number;
  scope_type: ScopeType;
  scope_code: string; // '' for global
  access_level: AccessLevel;
  granted_by: string | null;
  granted_at: string;
}

export interface UpsertGrantPayload {
  userId: number;
  scopeType: ScopeType;
  scopeCode?: string; // omitted/empty for global
  accessLevel: AccessLevel;
}

/** Super-admin only (mounted under /api/admin). */
export const accessGrantApi = {
  list: async (userId: number): Promise<AccessGrant[]> => {
    const { data } = await axiosClient.get(`/api/admin/access-grants/${userId}`);
    return data;
  },
  upsert: async (payload: UpsertGrantPayload): Promise<AccessGrant> => {
    const { data } = await axiosClient.post('/api/admin/access-grants', payload);
    return data;
  },
  remove: async (id: number): Promise<{ deleted: number }> => {
    const { data } = await axiosClient.delete(`/api/admin/access-grants/${id}`);
    return data;
  },
};
